/* ── Browser Notification API ────────────────────────────────────────
   Pede permissão ao usuário uma vez e dispara notificações nativas do
   sistema operacional quando há tarefas urgentes com prazo vencendo.
──────────────────────────────────────────────────────────────────── */

const ICON = "/favicon.ico";
const KEY_ASKED = "notif_permission_asked";

export function notificacoesSuportadas() {
  return "Notification" in window;
}

export function notificacoesPermitidas() {
  return notificacoesSuportadas() && Notification.permission === "granted";
}

export async function pedirPermissao() {
  if (!notificacoesSuportadas()) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const result = await Notification.requestPermission();
  localStorage.setItem(KEY_ASKED, "1");
  return result === "granted";
}

export function devePerguntar() {
  return (
    notificacoesSuportadas() &&
    Notification.permission === "default" &&
    !localStorage.getItem(KEY_ASKED)
  );
}

export function notificar(titulo, corpo, { tag, onClick } = {}) {
  if (!notificacoesPermitidas()) return;
  const n = new Notification(titulo, {
    body: corpo,
    icon: ICON,
    tag: tag || titulo,
    requireInteraction: false,
  });
  if (onClick) n.onclick = () => { window.focus(); onClick(); n.close(); };
  setTimeout(() => n.close(), 8000);
  return n;
}

/* Envia um batch de notificações de tarefas urgentes (agrupa para não spammar) */
export function notificarUrgentes(tarefas) {
  if (!notificacoesPermitidas() || !tarefas?.length) return;

  const vencidas  = tarefas.filter(t => t.urgencia === "vencida");
  const hoje      = tarefas.filter(t => t.urgencia === "hoje");
  const amanha    = tarefas.filter(t => t.urgencia === "amanha");

  if (vencidas.length) {
    notificar(
      `⚠ ${vencidas.length} tarefa${vencidas.length > 1 ? "s" : ""} vencida${vencidas.length > 1 ? "s" : ""}`,
      vencidas.slice(0, 3).map(t => `• ${t.titulo || t.subject || t.nome}`).join("\n"),
      { tag: "urgentes-vencidas" }
    );
  }
  if (hoje.length) {
    notificar(
      `🔔 ${hoje.length} tarefa${hoje.length > 1 ? "s" : ""} vence hoje`,
      hoje.slice(0, 3).map(t => `• ${t.titulo || t.subject || t.nome}`).join("\n"),
      { tag: "urgentes-hoje" }
    );
  }
  if (amanha.length && !vencidas.length && !hoje.length) {
    notificar(
      `📅 ${amanha.length} tarefa${amanha.length > 1 ? "s" : ""} vence amanhã`,
      amanha.slice(0, 2).map(t => `• ${t.titulo || t.subject || t.nome}`).join("\n"),
      { tag: "urgentes-amanha" }
    );
  }
}
